import React from "react";
import editor from '../../../assets/images/editor-choice.webp';
import blog1 from '../../../assets/images/blog1.webp';
import blog2 from '../../../assets/images/blog2.webp';
import blog3 from '../../../assets/images/blog3.webp';
import blog4 from '../../../assets/images/blog4.webp';
import blog5 from '../../../assets/images/blog5.webp';
import blog6 from '../../../assets/images/blog6.webp';
import { Link } from "react-router-dom";

const Blogcard = [
    {
        Image: blog1,
        date: "Sep 27, 2024",
        name: "By :Admin",
        comment: "8 Comments",
        heading: " Healthy, delicious meals delivered fast—customized just for you.",
        badge: "Nutrition"
 },


 {
    Image: blog2,
    date: "Sep 27, 2024",
    name: "By :Admin",
    comment: "12 Comments",
    heading: " Personalized nutrition made easy with doorstep meal delivery.",
    badge: "Diet Plan"
},
{
    Image: blog3,
    date: "Sep 27, 2024",
    name: "By :Admin",
    comment: "8 Comments",
    heading: "  Fresh, flavorful dishes delivered to match your lifestyle goals.",
    badge: "Nutrition"
},

{
    Image: blog4,
    date: "Sep 27, 2024",
    name: "By :Admin",
    comment: "12 Comments",
    heading: "Convenient, tailored meal plans delivered to your door daily.",
    badge: "Diet Plan"
},

{
    Image: blog5,
    date: "Sep 27, 2024",
    name: "By :Admin",
    comment: "12 Comments",
    heading: "Convenient, tailored meal plans delivered to your door daily.",
    badge: "Nutrition"
},

{
    Image: blog6,
    date: "Sep 27, 2024",
    name: "By :Admin",
    comment: "8 Comments",
    heading: "Tailored nutrition plans with hassle-free meal delivery service.",
    badge: "Diet Plan"
},

]



const BlogSection = () => {
    return (
        <>
            <section className="blog_section row_am">
                <div className="container">
                    <div className="blog_listing inner_page">
                        <div className="blog_post editor_choice">
                            <span className="choice_badge">
                                EDITOR
                                <br />
                                CHOICE
                            </span>
                            <div className="col-lg-6" data-aos="fade-in" data-aos-duration={1500}>
                                <div className="blog_img">
                                    <img src={editor} alt="image" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="text">
                                    <ul className="blog_info">
                                        <li>Sep 27, 2024</li>
                                        <li>By : Admin</li>
                                        <li>8 Comments</li>
                                    </ul>
                                    <h5>
                                        <Link to="/blog-detail">
                                            Freshly prepared meals, tailored to your needs, delivered daily!
                                        </Link>
                                    </h5>
                                    <p>
                                        Lorem Ipsum is simply dummy text of the printing and typtting
                                        industry lorem Ipsum has been the industrys standard dummy.
                                    </p>
                                    <div className="tag_more">
                                        <span className="tag">Nutrition</span>
                                        <Link to="/blog-detail">
                                            Read more <i className="icofont-arrow-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {Blogcard.map((data, index) =>
                         <div key={index} 
                        className="blog_post" data-aos="fade-up" data-aos-duration={1500}>
                            <Link to="#" className="img">
                                <img src={data.Image} alt="image" />
                            </Link>
                            <div className="text">
                                <ul className="blog_info">
                                    <li>data.date</li>
                                    <li>data.name</li>
                                    <li>data.comment</li>
                                </ul>
                                <h5>
                                    <Link to="/blog-detail">
                                       {data.heading}
                                    </Link>
                                </h5>
                                <div className="tag_more">
                                    <span className="tag">{data.badge}</span>
                                    <Link to="/blog-detail">
                                        Read more <i className="icofont-arrow-right" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                     )}
                       
                            
                    </div>
            
                    <div
                        className="pagination_block"
                        data-aos="fade-in"
                        data-aos-duration={1500}
                    >
                        <ul>
                            <li>
                                <Link to="#" className="prev">
                                    <i className="icofont-arrow-left" /> Prev
                                </Link>
                            </li>
                            <li>
                                <Link to="#">1</Link>
                            </li>
                            <li>
                                <Link to="#" className="active">
                                    2
                                </Link>
                            </li>
                            <li>
                                <Link to="#">3</Link>
                            </li>
                            <li>
                                <Link to="#">4</Link>
                            </li>
                            <li>
                                <Link to="#">5</Link>
                            </li>
                            <li>
                                <Link to="#">6</Link>
                            </li>
                            <li>
                                <Link to="#" className="next">
                                    Next <i className="icofont-arrow-right" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

        </>
    )
}
export default BlogSection;